<script>

    import AuthRequired from "./AuthRequired.svelte";
    import RestartRequired from "./RestartRequired.svelte";
    import PasswordError from "./PasswordError.svelte";
    import CheckpointError from "./CheckpointError.svelte";
    import {_} from '../lib/i18n';
    import TwoFactorError from "./TwoFactorError.svelte";
    import NotFriendError from "./NotFriendError.svelte";
    import RateLimitError from "./RateLimitError.svelte";

    export let params = {};
    let path = '';
    $: path = (params && params.path) ? params.path : '';
    export let analyze;


    let isTemporary;
    $: isTemporary = (analyze && analyze.temporary ? true : false);

    let authRequired;
    $: authRequired = (analyze ? (analyze.is_private && !analyze.handler) : false);

    let restartRequired;
    $: restartRequired = (analyze ? analyze.needRestart : false);

    let wrongPassword;
    $: wrongPassword = (analyze ? analyze.isPasswordError : false);

    let notFriend;
    $: notFriend = (analyze ? analyze.is_not_friend : false);

    let checkpoint;
    $: checkpoint = (analyze ? analyze.checkpoint : null);

    let twoFactor;
    $: twoFactor = ((checkpoint && checkpoint.data && checkpoint.data.two_factor_identifier) ? true : false);

    let someProblem;
    $: someProblem = analyze && analyze.handler &&
        ((checkpoint === null && analyze.handler.message === 'checkpointError')
        || (analyze.handler.message === 'analyzeError')
        || (analyze.handler.message === 'unknownError')
        || (analyze.handler.message === 'proxyError')
        || (analyze.handler.message === 'problemRequest'));


</script>

{#if analyze}
    {#if isTemporary}
        <p class="feed-status__text">
            {@html $_('analyzeControl.startAnalyzeBtnDescription')}
        </p>
    {:else if authRequired}
        <AuthRequired bind:analyze={analyze} show={authRequired} />
    {:else if restartRequired}
        <RateLimitError bind:analyze={analyze} show={restartRequired} />
    {:else if wrongPassword}
        <PasswordError bind:analyze={analyze} show={wrongPassword} />
    {:else if twoFactor}
        <TwoFactorError bind:analyze={analyze} show={twoFactor} />
    {:else if checkpoint}
        <CheckpointError bind:analyze={analyze} show={checkpoint} />
    {:else if notFriend}
        <NotFriendError bind:analyze={analyze} show={notFriend} />
    {:else if someProblem}
        <RestartRequired bind:analyze={analyze} />
    {/if}
{/if}



